import axios from 'axios'
import endpoints from '../configuration/endpoints'
import formatItinerary from '../utils/formatItinerary'

export const FETCH_ITINERARY_BEGIN = 'FETCH_ITINERARY_BEGIN'
export const FETCH_ITINERARY_SUCCESS = 'FETCH_ITINERARY_SUCCESS'
export const FETCH_ITINERARY_FAILURE = 'FETCH_ITINERARY_FAILURE'

export const fetchItineraryBegin = () => ({
  type: FETCH_ITINERARY_BEGIN
})

export const fetchItinerarySuccess = (identifier, itinerary) => ({
  type: FETCH_ITINERARY_SUCCESS,
  payload: { identifier, itinerary }
})

export const fetchItineraryError = error => ({
  type: FETCH_ITINERARY_FAILURE,
  payload: { error }
})

// Fetches the full cruise itinerary (including pre/post cruisetour days) from
// the dedicated itinerary endpoint. The package data returned with the quote
// only contains the sailing days, so cruisetour days are fetched separately.
export default function fetchItinerary({
  identifier,
  packageId,
  brand,
  sailDate,
  startDate,
  shipCode,
  agencyId,
  officeCode
}) {
  return dispatch => {
    const itineraryApi = `${
      endpoints.cruise
    }/${packageId}/itinerary?brand=${brand}&sailDate=${sailDate}&ship=${shipCode}&agencyId=${agencyId}&officeCode=${officeCode}`

    dispatch(fetchItineraryBegin())
    return axios
      .get(itineraryApi)
      .then(response => {
        const availableItinerary = response.data
        if (
          availableItinerary &&
          availableItinerary.package &&
          availableItinerary.package.length
        ) {
          const formattedItinerary = formatItinerary(
            availableItinerary.package,
            startDate || sailDate
          )
          dispatch(fetchItinerarySuccess(identifier, formattedItinerary))
        } else {
          dispatch(fetchItineraryError('Unable to retrieve itinerary data'))
        }
        return response
      })
      .catch(error => {
        dispatch(fetchItineraryError(error))
        return error
      })
  }
}
